import { Reducer } from 'redux'
import { LayoutActionTypes } from '../actions'
import { LayoutStoreModel, initialLayoutStoreState } from '../store.model'

export const layoutReducer: Reducer<LayoutStoreModel> = (
  state = initialLayoutStoreState,
  action
) => {
  switch (action.type) {
    case LayoutActionTypes.STORE_AUTOCOLLAPSE:
      return { ...state, sideNavAutoCollapse: action.payload }
    case LayoutActionTypes.TOGGLE_SIDE_HELP:
      return { ...state, sideHelpIsOpen: !state.sideHelpIsOpen }
    case LayoutActionTypes.TOGGLE_SIDE_CHANGELOG:
      return { ...state, sideChangelogIsOpen: !state.sideChangelogIsOpen }
    case LayoutActionTypes.SWTICH_RELEASE_NOTIFICATION:
      return { ...state, newReleaseNotification: action.payload }
    default:
      return state
  }
}
